import { render } from "./_tool-table.vue?vue&type=template&id=605d1bca"
import script from "./_tool-table.vue?vue&type=script&lang=js"
export * from "./_tool-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__